<template>
  <div id="prepare_modal" class="modal fade">
    <div id="print-area" class="modal-dialog modal-full" style="max-width: 660px">
      <div class="modal-content">
        <div class="modal-header" style="margin-bottom: 10px">
          <div class="rtl-float-left">
            <v-btn
              @click="printInvoice"
              id="print-button"
              style="height:auto"
              outline
              color="primary"
              >{{ $t('printLogs.printButton') }}</v-btn
            >
          </div>
          <button
            id="close-button"
            type="button"
            class="close"
            @click="closeModal('prepare_modal')"
          >
            &times;
          </button>
        </div>

        <div v-for="(data, index) in printData" :key="data.order_id">
          <table id="prepare-print-table" border="1">
            <tr>
              <td class="left-td">
                <p class="the-text-size">
                  {{ $t('columns.customerId') }}: <span class="info-text"> {{ data.user_id }} </span>
                </p>
                <p class="the-text-size">
                  {{ $t('columns.customerName') }}: <span class="info-text"> {{ data.full_name }} </span>
                </p>
                <p class="the-text-size">
                  {{ $t('addEditOrderCase.orderIdColon') }} <span class="info-text"> {{ data.theOrderID }} </span>
                </p>
                <p class="the-text-size">
                  {{ $t('columns.productName') }}: <span class="info-text"> {{ data.product_name }} </span>
                </p>
                <p class="the-text-size">
                  {{ $t('columns.quantity') }}: <span class="info-text"> {{ data.quantity }} </span>
                </p>
                <p class="the-text-size">
                  {{ $t('prepareToPrint.arrivedDateLabel') }}
                  <span class="info-text"> {{ data.from_date }} - {{ data.to_date }} </span>
                </p>
                <p class="the-text-size">
                  <qr-code :text="data.order_id.toString()" :size="65"></qr-code>
                </p>
              </td>
              <td class="right-td">
                <p class="the-text-size customer-address">
                  <span v-if="data.delivery_confirmed && data.delivery_type === 'office delivery'">{{ $t('delivery.deliveryMethodLabel') }}</span>
                  <span v-else-if="data.delivery_type === 'home delivery'">{{ $t('columns.deliveryAddress') }}</span>
                  <span v-else>{{ $t('columns.address') }}</span>
                </p>
                <br />
                <p class="the-text-size the-address" style="margin-bottom: 20px">
                  <span v-if="data.delivery_confirmed && data.delivery_type === 'office delivery'" class="info-text" style="font-weight: bold; color: #e65100;">
                    {{ $t('delivery.pickupInOfficeLabel') }}
                  </span>
                  <span v-else-if="data.delivery_type === 'home delivery' && data.delivery_address" class="info-text">
                    {{ [data.delivery_address.label, data.delivery_address.area, data.delivery_address.street, data.delivery_address.building_name, data.delivery_address.additional_directions].filter(Boolean).join(', ') || data.delivery_address.name || data.address }}
                  </span>
                  <span v-else class="info-text">{{ data.address }}</span>
                </p>
                <p class="the-text-size signature">{{ $t('prepareToPrint.signatureLabel') }}</p>
              </td>
            </tr>
          </table>

          <div v-if="(index + 1) % 3 === 0" style="page-break-after: always">&nbsp;</div>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['printData', 'closeModal'],

  methods: {
    printInvoice() {
      $('#close-button').hide()
      $('#print-button').hide()

      $('#print-area').printMe({ path: this.$_print_stylesheet_paths() })

      $('#close-button').show()
      $('#print-button').show()
    }
  }
}
</script>

<style scoped>
.modal {
  text-align: center;
  padding: 0 !important;
  overflow-x: auto;
}

.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-right: -4px;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/prepareToPrint.vue